import React, { useState, useEffect } from "react";
import "./Footer.css";
import "../../global/main.css";
import { Element, Link } from "react-scroll";

const Footer = () => {
  const [showArrow, setShowArrow] = useState(false);
  const [currentYear, setCurrentYear] = useState(new Date().getFullYear());

  useEffect(() => {
    const handleScroll = () => {
      setShowArrow(window.scrollY > 450);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <Element name="Footer">
      <footer className="Footer">
        {/* Wave Decoration - تم التعديل */}
        {/* <div className="footer-wave">
          <svg viewBox="0 0 1200 120" preserveAspectRatio="none">
            <path
              d="M0,0V46.29c47.79,22.2,103.59,32.17,158,28,70.36-5.37,136.33-33.31,206.8-37.5C438.64,32.43,512.34,53.67,583,72.05c69.27,18,138.3,24.88,209.4,13.08,36.15-6,69.85-17.84,104.45-29.34C989.49,25,1113-14.29,1200,52.47V0Z"
              opacity=".25"
              className="wave-fill"
            ></path>
            <path
              d="M0,0V15.81C13,36.92,27.64,56.86,47.69,72.05,99.41,111.27,165,111,224.58,91.58c31.15-10.15,60.09-26.07,89.67-39.8,40.92-19,84.73-46,130.83-49.67,36.26-2.85,70.9,9.42,98.6,31.56,31.77,25.39,62.32,62,103.63,73,40.44,10.79,81.35-6.69,119.13-24.28s75.16-39,116.92-43.05c59.73-5.85,113.28,22.88,168.9,38.84,30.2,8.66,59,6.17,87.09-7.5,22.43-10.89,48-26.93,60.65-49.24V0Z"
              opacity=".5"
              className="wave-fill"
            ></path>
            <path
              d="M0,0V5.63C149.93,59,314.09,71.32,475.83,42.57c43-7.64,84.23-20.12,127.61-26.46,59-8.63,112.48,12.24,165.56,35.4C827.93,77.22,886,95.24,951.2,90c86.53-7,172.46-45.71,248.8-84.81V0Z"
              className="wave-fill"
            ></path>
          </svg>
        </div> */}

        <div className="footer-container">
          {/* Main Footer Content */}
          <div className="footer-main">
            {/* Company Info */}
            <div className="footer-section company-info">
              <div className="logo-wrapper">
                <div className="footer-logo">
                  <i className="bx bxs-building-house"></i>
                  <span>اليسر</span>
                </div>
                <p className="company-description">
                  شركة رائدة في مجال الإرتقاء العمراني، نعمل يداً بيد لتحقيق
                  رؤيتك العمرانية بأعلى معايير الجودة والرفاهية.
                </p>
              </div>
            </div>

            {/* Quick Links */}
            <div className="footer-section quick-links">
              <h3 className="section-title">روابط سريعة</h3>
              <ul className="footer-links">
                <li>
                  <Link
                    to="Home"
                    offset={-100}
                    spy={true}
                    smooth={true}
                    duration={200}
                  >
                    <i className="bx bxs-home"></i>
                    الرئيسية
                  </Link>
                </li>
                <li>
                  <Link
                    to="About"
                    offset={-100}
                    spy={true}
                    smooth={true}
                    duration={200}
                  >
                    <i className="bx bxs-info-circle"></i>
                    من نحن
                  </Link>
                </li>
                <li>
                  <Link
                    to="Services"
                    offset={-100}
                    spy={true}
                    smooth={true}
                    duration={200}
                  >
                    <i className="bx bxs-briefcase"></i>
                    خدماتنا
                  </Link>
                </li>
                <li>
                  <Link
                    to="Contact"
                    offset={-100}
                    spy={true}
                    smooth={true}
                    duration={200}
                  >
                    <i className="bx bxs-phone"></i>
                    اتصل بنا
                  </Link>
                </li>
              </ul>
            </div>

            {/* Contact Info */}
            <div className="footer-section contact-info">
              <h3 className="section-title">معلومات الاتصال</h3>
              <div className="contact-item">
                <i className="bx bxs-map"></i>
                <span>سوريا , دشمق</span>
              </div>
              <div className="contact-item">
                <i className="bx bxs-phone"></i>
                <span>+963 950 037 310</span>
              </div>
              <div className="contact-item">
                <i className="bx bxs-envelope"></i>
                <span>info@alyousser.com</span>
              </div>
              <div className="contact-item">
                <i className="bx bxs-time"></i>
                <span>السبت - الخميس : 8:00 - 5:00</span>
              </div>
            </div>
          </div>

          {/* Footer Bottom */}
          <div className="footer-bottom">
            <div className="footer-divider"></div>
            <div className="bottom-content">
              <div className="copyright">
                {/* <p>
                  © {currentYear}
                  <span className="company-name"> اليسر للارتقاء العمراني</span>
                  . جميع الحقوق محفوظة.
                </p> */}
                <p>
                  جميع الحقوق محفوظة{" "}
                  <span className="company-name">
                    {" "}
                    لشركة اليسر للارتقاء العمراني
                  </span>{" "}
                  © {currentYear} .
                  {/* © {currentYear}
                  <span className="company-name"> اليسر للارتقاء العمراني</span>
                  . جميع الحقوق محفوظة. */}
                </p>
              </div>

              <div className="footer-legal">
                <span>سياسة الخصوصية</span>
                <span>شروط الاستخدام</span>
                <span>سياسة الاسترجاع</span>
              </div>
            </div>
          </div>
        </div>

        {/* Scroll to Top Button */}
        {showArrow && (
          <div className="scroll-to-top">
            <Link
              to="Home"
              spy={true}
              smooth={true}
              offset={0}
              duration={800}
              className="scroll-btn"
            >
              <i className="bx bxs-chevron-up"></i>
              <span className="scroll-tooltip">انتقل للأعلى</span>
            </Link>
          </div>
        )}
      </footer>
    </Element>
  );
};

export default Footer;
